export default __webpack_public_path__ + "static/media/iFMS_B_New.63749f0a.svg";